/**
 * Multiple Choice Set - form exports and hardcoded slug.
 * Registration is handled centrally in content-prompt/src/index.ts.
 */

export const MULTIPLE_CHOICE_SET_SLUG = 'scq';

export { MultipleChoiceSetForm } from './MultipleChoiceSetForm';
export type {
    MCQSetMediaType,
    MCQSetSourceType,
    MultipleChoiceSetFormState,
} from './types';
export { MEDIA_OPTIONS, DEFAULT_FORM_STATE } from './types';
export { QUESTION_TYPE_PRESETS, QUICK_CREATE_TEMPLATES } from './config';
export type { QuickCreateTemplate } from './config';
